import { ToggleButtonGroupProps } from 'react-aria-components';
import { useController } from 'react-hook-form';
import { cn } from '~/lib/utils';
import Button from '../ui/Button';
import ButtonGroup from '../ui/ButtonGroup';
import Icon, { IconName } from '../ui/Icon';

interface ToggleGroupFieldProps extends ToggleButtonGroupProps {
  control: any;
  name: string;
  options: Array<{ value: string; label: string; icon: IconName }>;
  label?: string;
}

export default function ToggleButtonGroupField({
  control,
  name,
  options,
  isDisabled,
  label,
}: ToggleGroupFieldProps) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <ButtonGroup
      errorMessage={error?.message}
      label={label}
      isDisabled={isDisabled}
      selectedKeys={new Set(field.value ? [field.value] : [])}
      onSelectionChange={(newSelection) => {
        const selectedValue = Array.from(newSelection)[0];
        field.onChange(selectedValue);
      }}
      selectionMode="single"
      className="flex w-full max-w-[400px] border border-input-border rounded-full"
    >
      {options.map(({ value, label, icon }) => {
        const isSelected = field.value === value;
        return (
          <Button
            key={value}
            id={value}
            asToggle
            variant={isSelected ? 'solid' : 'secondary'}
            size="inherit"
            className={cn(
              'border border-none rounded-none py-3.5 px-4 flex items-center gap-2 w-full first:rounded-l-full last:rounded-r-full inset-ring-0',
              {
                'disabled:opacity-100 pointer-events-none': isSelected,
              },
            )}
            isDisabled={isSelected}
          >
            <Icon name={icon} />
            {label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
